module.exports = __webpack_public_path__ + "img/site-background.2dd559cb.jpg";